import axios from "axios";
export default {
  namespaced: true,
  state: {
    bundle_templates: [],
  },
  getters: {
    bundle_templates(state) {
      return state.bundle_templates;
    },
  },
  mutations: {
    SET_BUNDLE_TEMPLATES(state, templates) {
      state.bundle_templates = templates;
    },
    ADD_BUNDLE_TEMPLATE(state, template) {
      state.bundle_templates.unshift(template);
    },
    EDIT_BUNDLE_TEMPLATE(state, template) {
      var index = state.bundle_templates.findIndex((a) => a.id == template.id);
      state.bundle_templates.splice(index, 1, template);
    },
    DELETE_BUNDLE_TEMPLATE(state, id) {
      state.bundle_templates = state.bundle_templates.filter((t) => t.id != id);
    },
  },
  actions: {
    async get_bundle_templates({ commit }) {
      let response = await axios.get("/bundle_templates");
      commit("SET_BUNDLE_TEMPLATES", response.data);
    },
    async add_bundle_template({ commit }, request) {
      let response = await axios.post("/bundle_template", request);
      commit("ADD_BUNDLE_TEMPLATE", response.data);
    },
    async edit_bundle_template({ commit }, request) {
      let response = await axios.put("/bundle_template", request);
      commit("EDIT_BUNDLE_TEMPLATE", response.data);
    },
    async delete_bundle_template({ commit }, id) {
      await axios.delete("/bundle_template/" + id);
      commit("DELETE_BUNDLE_TEMPLATE", id);
    },
  },
};
